<template>
	<v-navigation-drawer class="left-bar" v-model="menu" absolute mobile-breakpoint="1024" >
		<div class="left-bar__logo">
			<!-- <img class="logo" src="../../assets/logo.png" alt="logo"> -->
			<h2>Logo</h2>
			<v-text-field label="Search" class="search" prepend-inner-icon="mdi-file-search-outline" solo hide-details></v-text-field>
		</div>

		<v-list>
			<v-list-item link to="/home">
				<v-list-item-icon>
					<v-icon>mdi-home</v-icon>
				</v-list-item-icon>

				<v-list-item-title>Products</v-list-item-title>
			</v-list-item>

			<v-list-item link to="/orders">
				<v-list-item-icon>
					<v-icon>mdi-format-list-bulleted</v-icon>
				</v-list-item-icon>

				<v-list-item-title>Orders</v-list-item-title>
			</v-list-item>

			<v-list-item link to="/orders">
				<v-list-item-icon>
					<v-icon>mdi-account-cog</v-icon>
				</v-list-item-icon>

				<v-list-item-title>Settings</v-list-item-title>
			</v-list-item>
		</v-list>
	</v-navigation-drawer>
</template>

<script>
	import './style.scss';

	export default {
		name: 'LeftBar',
		components: {},
		data: () => {
			return {}
		},

		computed: {

			menu: {
				get () { 
					return this.$store.getters['Common/getMenu'];
				},
				set (value) {
					this.$store.dispatch('Common/toggleMenu', value);
				}
			}
		}
	}
</script>

<style>

</style>
